export default __webpack_public_path__ + "static/media/d15.5fb303a8.png";